import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles } from '@material-ui/core';
import { updateExpensesPagination } from '../../../store/actions/expense/expense_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import SearchComponent from '../../ui_components/search';
import history from '../../../services/history';
import ExpensesTable from './expenses_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const ExpenseList = ({ expenses }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = expenses;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateExpensesPagination({...expenses, page: 0, filters: { ...filters, search }}))
    }

    const handleAddExpenseClick = () => {
        history.push(REACT_ROUTES.EXPENSE);
    }

    return (
        <Container className={container}>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddExpenseClick}
                    >
                        Kreirajte novi trošak
                    </Button>
                </Grid>
            </Grid>
            <ExpensesTable />
        </Container>
    )
}

ExpenseList.propTypes = {
    expenses: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenses: state.expenses
});

export default connect(mapStateToProps)(ExpenseList);
